import React from 'react';
import {Form, Label, Segment, Accordion, Dropdown, TextArea, Button} from 'semantic-ui-react';
import axios from 'axios';
import '../css/QAdminAPI.css'


class QGetOrganizationKey extends React.Component {

    constructor(props) {
        super(props);
        this.state = {organization:null, response:null}
        }

    // Sent download link to the user email.
  getOrganizationKey = () => {
    if (!this.state.organization){ 
    alert("Please select an organization.")
    return
    }
    const url = "/admin/organization_key" // /link/Qfin/6.2
    const params = {organization: this.state.organization, token:this.props.getToken()}
    let result = axios({method: "get", url:url, params: params})
    result.then((response)=> {this.setState({response: response.data.response})},
                 (error) => {this.setState({response: error.response.data.detail}); this.props.getUser()})

  }

    render () {
        return (
            <Segment  className='getSegementStyle'>
            <Accordion.Title 
            active={this.props.activeIndex === this.props.index}
            content= {(
                <>
                <Label className='methodLabel' color='blue'> Get an organisation (company) key </Label>
                </>
                )} 
                index={this.props.index}
                onClick={this.props.handleClick}
            />
            <Accordion.Content
            active={this.props.activeIndex === this.props.index} 
            content={(
            <>
            <Form>
            <Form.Field >
                <label>Organization</label>
                <Dropdown placeholder='Select organization' selection options={this.props.organizationNames}
                onChange={(event, {name, value}) => this.setState({organization: value, response:""})}/>
                </Form.Field>
                <Form.Field>
                <Button className="submitBtn" fluid onClick={(e) => this.getOrganizationKey()}>
                Submit
                </Button>
                </Form.Field> 
                <Form.Field>
                <label>Response</label>
                <TextArea value={this.state.response}/>
                </Form.Field>     
            </Form>
            </>
            )} />
            </Segment>
        )
    }

}

export default QGetOrganizationKey